import { CommonEnums } from '../../common.enums';

export class FileTransfer_Inst {
    fileTransfer_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    src_Conn_ValidCd: string;
    tgt_Conn_ValidCd: string;
    retryEnabled: string;
	numOfRetryAttempts: number;
	retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.fileTransfer_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
         this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.src_Conn_ValidCd = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_Conn_ValidCd = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled =  CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts =  2;
        this.retryWaitTime =  60;
    }

    getPrimaryKey(): string {
        return this.fileTransfer_Inst_Id + '.' + this.dxFlow_Id;
    }

    copy(): FileTransfer_Inst {
        let fileTransfer_InstTmp: FileTransfer_Inst = new FileTransfer_Inst();

        fileTransfer_InstTmp.fileTransfer_Inst_Id = this.fileTransfer_Inst_Id;
        fileTransfer_InstTmp.nm = this.nm;
        fileTransfer_InstTmp.description = this.description;
        fileTransfer_InstTmp.ver = this.ver;
        fileTransfer_InstTmp.valid_Cd = this.valid_Cd;
        fileTransfer_InstTmp.dxFlow_Id = this.dxFlow_Id;
        fileTransfer_InstTmp.updateBy = this.updateBy;
        fileTransfer_InstTmp.lastUpdateBy = this.lastUpdateBy;
        fileTransfer_InstTmp.updateDt = this.updateDt;
        fileTransfer_InstTmp.disableFlg = this.disableFlg;
        fileTransfer_InstTmp.src_ConnNm = this.src_ConnNm;
        fileTransfer_InstTmp.tgt_ConnNm = this.tgt_ConnNm;
        fileTransfer_InstTmp.retryEnabled =this.retryEnabled;
        fileTransfer_InstTmp.retryWaitTime= this.retryWaitTime;
        fileTransfer_InstTmp.src_Conn_ValidCd = this.src_Conn_ValidCd;
        fileTransfer_InstTmp.tgt_Conn_ValidCd = this.tgt_Conn_ValidCd;
        fileTransfer_InstTmp.numOfRetryAttempts=this.numOfRetryAttempts;
        

        return fileTransfer_InstTmp;
    }

    copyFrom(fileTransfer_InstTmp: FileTransfer_Inst): void {
        this.fileTransfer_Inst_Id = fileTransfer_InstTmp.fileTransfer_Inst_Id;
        this.nm = fileTransfer_InstTmp.nm;
        this.description = fileTransfer_InstTmp.description;
        this.ver = fileTransfer_InstTmp.ver;
        this.valid_Cd = fileTransfer_InstTmp.valid_Cd;
        this.dxFlow_Id = fileTransfer_InstTmp.dxFlow_Id;
        this.updateBy = fileTransfer_InstTmp.updateBy;
        this.updateDt = fileTransfer_InstTmp.updateDt;
        this.disableFlg = fileTransfer_InstTmp.disableFlg;
        this.lastUpdateBy=fileTransfer_InstTmp.lastUpdateBy;
        this.src_ConnNm = fileTransfer_InstTmp.src_ConnNm;
        this.tgt_ConnNm = fileTransfer_InstTmp.tgt_ConnNm;
        this.retryEnabled=fileTransfer_InstTmp.retryEnabled;
        this.retryWaitTime =fileTransfer_InstTmp.retryWaitTime;
        this.src_Conn_ValidCd = fileTransfer_InstTmp.src_Conn_ValidCd;
        this.numOfRetryAttempts=fileTransfer_InstTmp.numOfRetryAttempts;
        this.tgt_Conn_ValidCd = fileTransfer_InstTmp.tgt_Conn_ValidCd;
    }

    compare(fileTransfer_InstTmp: FileTransfer_Inst): string {
        let fileTransfer_InstString: string = this.toString(false);
        let fileTransfer_InstTmpString: string = fileTransfer_InstTmp.toString(false);

        if (fileTransfer_InstString != fileTransfer_InstTmpString) {
            return fileTransfer_InstString + ', ' + fileTransfer_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "FileTransfer_Inst [fileTransfer_Inst_Id=" + this.fileTransfer_Inst_Id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", dxFlow_Id=" + this.dxFlow_Id +
            ", updateBy=" + this.updateBy +
            ", updateDt=" + this.updateDt +
            ", disableFlg=" + this.disableFlg +
             ",retryEnabled ="+ this.retryEnabled +
            ",numOfRetryAttempts ="+ this.numOfRetryAttempts +
            ",retryWaitTime =" + this.retryWaitTime;

        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy+
            ", src_ConnNm=" + this.src_ConnNm +
            ", tgt_ConnNm=" + this.tgt_ConnNm +
            ", src_Conn_ValidCd=" + this.src_Conn_ValidCd +
            ", tgt_Conn_ValidCd=" + this.tgt_Conn_ValidCd; 
        }

        str += ']';

        return str;
    }
}



